"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _translations = require("../../libs/translationsUtils/translations");

var tableOfContentsPlugin = {
  requires: 'widget',
  icons: 'contents',
  init: function init(editor) {
    window.CKEDITOR.dialog.add('table-of-contents', function () {
      return {
        title: (0, _translations.t)('Forum', 'editor.table_of_contents.confirmation_modal.title'),
        contents: [{
          id: 'info',
          elements: [{
            type: 'html',
            html: '<p>' + (0, _translations.t)('Forum', 'editor.table_of_contents.confirmation_modal.description') + '</p>'
          }, {
            id: 'chkInsertOpt',
            type: 'checkbox',
            label: (0, _translations.t)('Forum', 'editor.table_of_contents.confirmation_modal.checkbox'),
            default: true,
            setup: function setup(widget) {
              widget.data.chkInsertOpt === undefined ? this.setValue(false) : this.setValue(widget.data.chkInsertOpt);
            },
            commit: function commit(widget) {
              widget.setData('chkInsertOpt', this.getValue());
            }
          }]
        }],
        onOk: function onOk() {
          window.insided.trackEvent('userevent', {
            type: 'Table of Contents inserted',
            event_source: editor.config.environment
          });
        }
      };
    });
    editor.widgets.add('table-of-contents', {
      button: 'Insert Table of Contents',
      template: '<div class="widget-toc"></div>',
      allowedContent: 'div(!widget-toc);',
      dialog: 'table-of-contents',
      upcast: function upcast(element) {
        return element.name === 'div' && element.hasClass('widget-toc');
      },
      init: function init() {
        editor.on('saveSnapshot', function () {
          buildToc(this.element);
        }.bind(this));
        this.on('focus', function () {
          buildToc(this.element);
        }.bind(this));
        buildToc(this.element);

        if (this.element.hasClass('toc_root')) {
          this.setData('chkInsertOpt', true);
        }
      },
      data: function data() {
        this.element.removeClass('toc_root');

        if (this.data.chkInsertOpt) {
          this.element.addClass('toc_root');
        }
      }
    });

    function buildToc(element) {
      // set everything up
      var CKEDITOR = window.CKEDITOR;
      element.setHtml(''); // eslint-disable-next-line new-cap

      var Container = new CKEDITOR.dom.element('ul');
      Container.appendTo(element);
      var findRoot;

      if (element.hasClass('toc_root')) {
        findRoot = 'h2';
      } else {
        findRoot = 'h1,h2,h3,h4,h5,h6,';
      }

      var headings = editor.editable().find(findRoot);
      var parentLevel = 1;
      var length = headings.count(); // get each heading

      for (var i = 0; i < length; ++i) {
        var currentHeading = headings.getItem(i);
        var text = currentHeading.getText();
        var newLevel = parseInt(currentHeading.getName().substr(1, 1));
        var diff = newLevel - parentLevel; // set the start level incase it is not h1

        if (i === 0) {
          diff = 0;
          parentLevel = newLevel;
        } // we need a new ul if the new level has a higher number than its parents number


        if (diff > 0) {
          var containerLiNode = Container.getLast(); // eslint-disable-next-line new-cap

          var ulNode = new CKEDITOR.dom.element('ul');
          ulNode.appendTo(containerLiNode);
          Container = ulNode;
          parentLevel = newLevel;
        } // we need to get a previous ul if the new level has a lower number than its parents number


        if (diff < 0) {
          while (diff++ !== 0) {
            var parent = Container.getParent().getParent();
            Container = parent.getName() === 'ul' ? parent : Container;
          }

          parentLevel = newLevel;
        } // we can add the list item if there is no difference
        // if(text === ''){text = 'empty'}


        if (text == null || text.trim() === '') {
          text = '&nbsp;';
        }

        var id = text.replace(/ /g, '+');
        currentHeading.setAttribute('id', id);
        var liNode = CKEDITOR.dom.element.createFromHtml('<li><a href="#' + id + '">' + text + '</a></li>');
        liNode.appendTo(Container);
      }
    }
  }
};
var _default = tableOfContentsPlugin;
exports.default = _default;